import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import { Media, mbSize } from '../../../../theme'

export const MobileNavRoot = styled.div`
  display: none;
  z-index: 10000;
  ${Media.lessThan(Media.small)} {
    display: block;
    margin-left: ${mbSize(56)};
  }
`

export const MobileNavMenuButton = styled.button`
  position: relative;
  z-index: 2;
  display: flex;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  > svg {
    width: ${mbSize(32)};
    height: ${mbSize(32)};
  }
`

export const MobileNavBackdrop = styled.div`
  position: fixed;
  top: ${mbSize(120)};
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  /* 低于 HeaderWrapper(10000)，避免 portal 到 body 后盖住导航面板 */
  z-index: 9999;
`

export const MobileNavPanel = styled.nav`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: ${mbSize(120)};
  left: 0;
  width: 100%;
  max-height: calc(100vh - ${mbSize(240)});
  background: #ffffff;
  color: #0f172a;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 1;
`
export const MobileNavScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  border-top: 1px solid #cccccc;
  padding: ${mbSize(8)} ${mbSize(48)} ${mbSize(60)};
  -webkit-overflow-scrolling: touch;
`

export const MobileNavDivider = styled.div`
  width: 100%;
  height: 0.5px;
  min-height: 0.5px;
  background: #cccccc;
  margin-top: ${mbSize(40)};
`

const accordionChevronCss = css`
  > svg {
    flex-shrink: 0;
    transition: transform 0.3s;
  }

  .header-down-arrow-icon path {
    stroke: #0f172a;
  }
`

export const MobileNavAccordionButton = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: ${mbSize(40)};
  border: none;
  background: transparent;
  font-family: Inter, system-ui, sans-serif;
  font-size: ${mbSize(28)};
  font-weight: 700;
  line-height: 1.21;
  color: #0f172a;
  cursor: pointer;
  text-align: left;
  ${accordionChevronCss}

  > svg {
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  }
`

export const MobileNavNestedAccordionButton = styled.button<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: none;
  background: transparent;
  font-family: Inter, system-ui, sans-serif;
  font-size: ${mbSize(24)};
  font-weight: 500;
  line-height: 1.21;
  color: #0f172a;
  cursor: pointer;
  text-align: left;
  ${accordionChevronCss}

  > svg {
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0)')};
  }
`

/** 一级菜单展开内容区 */
export const MobileNavAccordionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${mbSize(40)};
  margin: ${mbSize(32)} 0 0 ${mbSize(20)};
`

/** Support 内嵌套手风琴展开区 */
export const MobileNavNestedBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${mbSize(40)};
  margin: 0 0 0 ${mbSize(20)};
`

export const MobileNavNestedSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const MobileNavDirectLink = styled(Link)`
  display: block;
  padding-top: ${mbSize(40)};
  font-family: Inter, system-ui, sans-serif;
  font-size: ${mbSize(28)};
  font-weight: 700;
  line-height: 1.21;
  color: #0f172a;
  text-decoration: none;
`

export const MobileNavSectionTitle = styled.h3`
  margin: 0;
  padding: ${mbSize(10)} ${mbSize(8)};
  font-family: Inter, system-ui, sans-serif;
  font-size: ${mbSize(24)};
  font-weight: 400;
  line-height: 1.21;
  color: #0f172a;
`

/** Resources 分组标题 */
export const MobileNavGroupTitle = styled(MobileNavSectionTitle)`
  font-weight: 700;
`

export const MobileNavIconGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, max-content);
  gap: ${mbSize(40)} ${mbSize(48)};
  padding: 0;
  list-style: none;
`

export const MobileNavIconGridItem = styled.li`
  min-width: 0;
`

export const MobileNavIconAnchor = styled.a<{ $highlight?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${mbSize(8)};
  font-family: Inter, system-ui, sans-serif;
  font-size: ${mbSize(22)};
  font-weight: 400;
  line-height: 1.21;
  color: #0f172a;
  text-decoration: none;
  background: ${({ $highlight }) => ($highlight ? '#fff0ec' : 'transparent')};
  border-radius: ${mbSize(8)};
  padding: ${mbSize(4)} ${mbSize(4)} ${mbSize(4)} 0;

  > svg {
    flex-shrink: 0;
    width: ${mbSize(24)};
    height: ${mbSize(24)};
  }
`

export const MobileNavSupportBanner = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  width: calc(100% + ${mbSize(20)} + ${mbSize(48)} * 2);
  margin-left: calc(-1 * (${mbSize(20)} + ${mbSize(48)}));
  margin-right: -${mbSize(48)};
  margin-top: ${mbSize(8)};
  padding: ${mbSize(20)} ${mbSize(16)};
  background: #f3512b;
  font-family: Inter, system-ui, sans-serif;
  font-size: ${mbSize(28)};
  font-weight: 700;
  line-height: 1.21;
  color: #ffffff;
  text-decoration: none;
  box-sizing: border-box;

  > svg {
    margin-left: ${mbSize(12)};
    flex-shrink: 0;
  }

  &:hover {
    background: #e8482b;
    color: #ffffff;
  }
`

export const MobileNavAuthButtons = styled.div`
  display: flex;
  flex-shrink: 0;
  gap: ${mbSize(40)};
  padding: 0 ${mbSize(48)} ${mbSize(60)};
  background: #ffffff;
`

export const MobileNavAuthButton = styled.a<{ $variant?: 'signin' | 'register' }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${mbSize(32)} 0;
  border-radius: 4px;
  font-family: Inter, system-ui, sans-serif;
  font-size: ${mbSize(24)};
  font-weight: 700;
  line-height: 1;
  color: #ffffff;
  text-decoration: none;
  background: ${({ $variant }) => ($variant === 'register' ? '#f3512b' : '#0f172a')};
`
